import { render } from "./PhoneForm.vue?vue&type=template&id=738f6e2b"
import script from "./PhoneForm.vue?vue&type=script&lang=js"
export * from "./PhoneForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__